import { FilterList } from '@mui/icons-material'
import { Badge, Box, Button, Checkbox, FormControlLabel, IconButton, Popover, Tooltip, Typography } from '@mui/material'
import { bindPopover, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks'
import { useTranslation } from 'react-i18next'
import { formatTechnologyType } from '../../store/utils'

type TechTypeFilterButtonProps = {
  availableTypes: string[]
  selectedTypes: string[]
  onToggle: (type: string) => void
  onClear: () => void
}

const TechTypeFilterButton = ({ availableTypes, selectedTypes, onToggle, onClear }: TechTypeFilterButtonProps) => {
  const { t } = useTranslation()
  const popupState = usePopupState({ variant: 'popover', popupId: 'tech-type-filter' })

  return (
    <>
      <Tooltip title={t('components.button.filterTechnologyTypes')}>
        <IconButton
          size="small"
          color={selectedTypes.length > 0 ? 'primary' : 'default'}
          aria-label={t('components.button.filterTechnologyTypes')}
          {...bindTrigger(popupState)}
        >
          <Badge badgeContent={selectedTypes.length || undefined} color="primary">
            <FilterList />
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: -8, horizontal: 'center' }}
      >
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 200 }}>
          <Typography variant="h6" color="text.mediumEmphasis">
            {t('page.adminsPage.filtering.types')}
          </Typography>

          {availableTypes.length === 0 ? (
            <Typography variant="body2">{t('page.adminsPage.filtering.noTypes')}</Typography>
          ) : (
            availableTypes.map(type => (
              <FormControlLabel
                key={type}
                control={<Checkbox checked={selectedTypes.includes(type)} onChange={() => onToggle(type)} />}
                label={formatTechnologyType(type)}
              />
            ))
          )}

          {selectedTypes.length > 0 && (
            <Button variant="text" size="small" onClick={onClear}>
              {t('page.adminsPage.filtering.clear')}
            </Button>
          )}
        </Box>
      </Popover>
    </>
  )
}

export default TechTypeFilterButton
